import React from 'react';
import { Box, Button, Tooltip, useTheme } from '@mui/material';
import FileDownloadIcon from '@mui/icons-material/FileDownload';

export const ExportButton = ({ 
  // Accept onClick handler and loading state
  onClick,
  isExporting 
}) => {
  const theme = useTheme();
  
  return (
    <Tooltip title="Export as PNG">
      <Button
        variant="outlined"
        size="small"
        onClick={onClick} // Use passed-in handler
        disabled={isExporting} // Use passed-in state
        sx={{
          minWidth: '40px',
          height: '32px',
          borderColor: theme.palette.grey[300],
          color: 'rgb(48,122,215)',
          '&:hover': {
            backgroundColor: 'rgba(48,122,215,0.1)',
            borderColor: 'rgb(48,122,215)'
          }
        }}
      >
        {isExporting ? (
          <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center', width: '24px', height: '24px' }}>
            <Box
              sx={{
                width: '16px',
                height: '16px',
                border: '2px solid rgba(48,122,215,0.2)',
                borderTop: '2px solid rgb(48,122,215)',
                borderRadius: '50%',
                animation: 'spin 1s linear infinite',
                '@keyframes spin': {
                  '0%': { transform: 'rotate(0deg)' },
                  '100%': { transform: 'rotate(360deg)' }
                }
              }}
            />
          </Box>
        ) : (
          <FileDownloadIcon fontSize="small" />
        )}
      </Button>
    </Tooltip>
  );
}; 